<template>
  <div>
    <div class="col-md-12 mx-auto">
      <div class="centerTitle">
        <span class="red-dotl"></span>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <p class="title"
              >{{
                language_id_new == 3
                  ? this.timer.minutes.toLocaleString("ar-SA")
                  : this.timer.minutes
              }}:{{
                language_id_new == 3
                  ? this.timer.seconds.toLocaleString("ar-SA")
                  : this.timer.seconds
              }}</p
            >
            <p
              class="text"
              v-bind:class="
                language_id == 'ar' ? 'mr-1 mr-md-3' : 'ml-1 ml-md-3'
              "
            >
              <span class="d-block">{{ $tc("TillYourBookingExpires") }}</span>
              <!-- {{allLanguageData.Timer[1]}} -->
            </p>
          </div>
          <!-- <button
            class="check_offer"
            @click="$refs['OfferPopup'].show()"
            v-if="!isOfferApplied"
          >
            Offers
          </button>
          <button
            class="check_offer"
            @click="removeAddedOffer"
            v-else-if="isOfferApplied"
          >
            x Remove Offers
          </button> -->
        </div>
        <span class="red-dotr"></span>
      </div>
    </div>
    <!-- ERROR MODAL -->
    <b-modal
      ref="modal"
      id="modal-1"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
    >
      <p class="my-4 black text-center">{{ ErrorMessage }}</p>
      <div class="text-center">
        <b-button
          @click="closeModal"
          class="text-center mx-auto mt-3 btn-danger"
          >{{ $tc("CLOSE") }}</b-button
        >
      </div>
    </b-modal>
    <!-- ERROR MODAL ENDS-->
    <!--Offer ERROR MODAL -->
    <b-modal
      ref="offererrormodal"
      id="modal-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
    >
      <p class="my-4 black text-center">{{ ErrorMessage }}</p>
      <div class="text-center">
        <b-button
          @click="closeOfferErrorModal"
          class="text-center mx-auto mt-3 btn-danger"
          >{{ $tc("CLOSE") }}</b-button
        >
      </div>
    </b-modal>
    <!-- Offer Error MODAL ENDS-->

    <div>
      <b-modal
        hide-footer
        centered
        id="OfferPopup"
        ref="OfferPopup"
        class="light-red-color package-offer-modal"
        content-class="package-offer-modal-border"
        size="xl"
      >
        <OfferModal
          :type="String(1)"
          :getOffersCollection="filteredOfferSelection"
          :refId="'OfferPopup'"
          :fnb_items="[]"
          :offerGroupTypes="offerGroupTypes || []"
          @onApplyOffer="handleApplyOffer"
          @handleOfferTabChange="handleOfferTabChange"
        />
      </b-modal>
    </div>
    <div class="col-12 pb-4 mt-5">
      <div class="row">
        <div class="col-4">
          <img
            :src="
              checkBaseUrl(
                getLangSpecificAttribute(
                  scheduleData.altMovieContent,
                  getCurrentLang().brij_lang_id,
                  'artwork'
                ) || scheduleData.artwork
              )
            "
            class="img-fluid rounded"
          />
        </div>
        <div class="col-8">
          <h5 class="movie-name mb-3">
            {{ scheduleData.MovieTitle }} ({{ scheduleData.SelectedFormat }})
            ({{ scheduleData.Language }})
          </h5>

          <div class="d-flex mb-4">
            <div class="h4">{{ scheduleData.Certificate }}</div>
            <div class="mx-3">&bull;</div>
            <div class="h4">{{ scheduleData.Genre }}</div>
            <div class="mx-3">&bull;</div>
            <div class="h4"
              >{{
                language_id_new == 3
                  ? scheduleData.runtime.toLocaleString("ar-SA")
                  : scheduleData.runtime
              }}
              {{ $tc("minutes") }}</div
            >
          </div>

          <div class="mb-4" v-if="director">
            <h4>{{ $tc("DirectedBy") }}</h4>
            <h5>{{ director }}</h5>
          </div>
          <div class="mb-4">
            <p class="h1">
              {{ scheduleData.ShowDate }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                scheduleData.ShowTime
              }}
            </p>
          </div>
          <div>
            <ul class="list-inline ticket-details">
              <li class="list-inline-item">
                <span class="format ml-0">{{
                  scheduleData.SelectedFormat || "2D"
                }}</span>
              </li>
              <li class="list-inline-item">
                <div class="mt-1">
                  x
                  {{
                    language_id_new == 3
                      ? scheduleData.ticket_count.toLocaleString("ar-SA")
                      : scheduleData.ticket_count || 2
                  }}
                  {{ $tc("Tickets") }}
                </div>
              </li>

              <br />
              <li class="list-inline-item">
                <div class="mt-1"
                  >{{ $tc("Seats") }} {{ scheduleData.SeatName }}</div
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="extra-ticket-details my-4">
            <!-- ADD COLLAPSE  -->
            <div class="mb-2">{{ $tc("Tickets") }}</div>
            <div>
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  {{ scheduleData.MovieTitle }} x
                  <span class="ticket-count">{{
                    language_id_new == 3
                      ? scheduleData.ticket_count.toLocaleString("ar-SA")
                      : scheduleData.ticket_count
                  }}</span>
                </div>
                <div>
                  {{ curr_code }}
                  {{ currFormat(scheduleData.amount) }}
                </div>
              </div>
            </div>
            <div class="mb-2" v-if="add_ons_array.length">
              {{ $tc("Addons") }}
            </div>
            <div>
              <div
                class="d-flex align-items-center justify-content-between"
                v-if="add_ons_array.length"
                v-for="(data, idx) in add_ons_array"
                :key="idx"
              >
                <div>
                  {{ data.addons_name }} x
                  <span class="ticket-count">{{
                    language_id_new == 3
                      ? data.quantity.toLocaleString("ar-SA")
                      : data.quantity
                  }}</span>
                </div>
                <div>
                  {{ curr_code }}
                  {{
                    language_id_new == 3
                      ? data.single_add_ons_price.toLocaleString("ar-SA")
                      : currFormat(data.single_add_ons_price)
                  }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="fnbItemDataArry.length" class="extra-ticket-details mb-4">
            <!-- ADD COLLAPSE  -->
            <div class="mb-2">{{ $tc("FoodAndDrinks") }}</div>
            <div>
              <div
                v-for="(fnb, fnbKey) in fnbItemDataArry"
                :key="fnbKey"
                class="d-flex align-items-center justify-content-between"
              >
                <div
                  :style="
                    language_id_new == 3 ? 'direction: ltr' : 'direction: ltr'
                  "
                  >{{ fnb.title }} x
                  {{
                    language_id_new == 3
                      ? (
                          fnb.qty ||
                          fnb.Quantity ||
                          fnb.Qty ||
                          fnb.quantity ||
                          0
                        ).toLocaleString("ar-SA")
                      : fnb.qty || fnb.Quantity || fnb.Qty || fnb.quantity || 0
                  }}</div
                >
                <div>
                  {{ curr_code }}
                  {{
                    currFormat(
                      parseFloat(fnb.fp_total_amount) *
                        parseInt(
                          fnb.qty ||
                            fnb.Quantity ||
                            fnb.Qty ||
                            fnb.quantity ||
                            0
                        )
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="ticket-total my-4"
          v-if="
            appliedBrijVoucher &&
              appliedBrijVoucher.BoxOffice.TotalOfferPrice > 0
          "
        >
          <div class="" style="color:var(--green);font-weight: bold;">{{
            $tc("DISCOUNT")
          }}</div>
          <div style="color:var(--green);font-weight: bold;"
            >- {{ curr_code }}
            {{ getSafe(() => appliedBrijVoucher.BoxOffice.TotalOfferPrice, 0) }}
          </div>
        </div>
        <div class="ticket-total my-4">
          <div>{{ $tc("SubTotal") }}</div>
          <div
            >{{ curr_code }}
            {{
              currFormat(totalAmount) -
                getSafe(() => appliedBrijVoucher.BoxOffice.TotalOfferPrice, 0)
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-flex justify-content-between alighn-items-center fixed-next"
      style="left: calc(50% - 250px) !important;"
    >
      <div
        class=""
        v-if="OffersData.length > 0"
        :style="
          langName == 'ar' ? { marginLeft: '120px' } : { marginRight: '120px' }
        "
      >
        <div
          class="btn-round"
          @click="$refs['OfferPopup'].show()"
          v-if="!isOfferApplied"
        >
          <div class="btn-content">
            <div>
              <div class="h2 font-weight-bold text-red">{{
                $tc("Offers")
              }}</div>
              <!-- <div class="h3 font-weight-bold">{{ $tc("Checkout") }}</div> -->
            </div>
          </div>
        </div>
        <div
          class="btn-round"
          @click="removeAddedOffer"
          v-else-if="isOfferApplied"
        >
          <div class="btn-content">
            <div>
              <div class="h2 font-weight-bold text-red">{{
                $tc("Remove Offers")
              }}</div>
              <!-- <div class="h3 font-weight-bold">{{ $tc("Checkout") }}</div> -->
            </div>
          </div>
        </div>
      </div>

      <router-link to @click.native="onClickProceed()" class="">
        <div class="btn-round">
          <div class="btn-content">
            <div>
              <div class="h2 font-weight-bold text-red">{{ $tc("Next") }}</div>
              <div class="h3 font-weight-bold">{{ $tc("Checkout") }}</div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import bookingService from "@/services/bookingService.js";
import { BASEURL } from "@/config/index.js";
import { groupBy } from "lodash";
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import OfferModal from "@/components/popups/OfferModal.vue";

import moment from "moment";

export default {
  name: "Confirm booking",
  components: {
    OfferModal,
  },
  data() {
    return {
      OffersData: [],
      isActivePromotionHit: false,
      isOfferApplied: false,
      appliedBrijVoucher: null,
      cardInputErrorMsg: "",
      errorMessage: "",
      cardInputsuccessMsg: "",
      appliedPromoName: "",
      appliedOfferType: "",
      filteredOfferSelection: [],
      offerGroupTypes: [],
      reserve_id: "",
      reserveDetails: {},
      ErrorMessage: "Something went wrong",
      scheduleData: {
        CinameName: "",
        MovieTitle: "",
        ScreenName: "",
        ShowDate: "",
        ShowTime: "",
        Location: "",
        Experience: "",
        Currency: "",
        SeatName: "",
        SchID: "",
        //extra
        MovieImage: "",
        runtime: "",
        Genre: "",
        Certificate: "",
        SelectedFormat: "",
        Language: "",
        director: "",
        ticket_count: "",
        amount: 0,
        fnb_total: 0,
        artwork: "",
        altMovieContent: "",
      },
      totalAmount: 0,
      reservationDetails: null,
      cinemaID: 0,
      selectedSeatsNew: [],
      fnbItemData: [],
      fnbItemDataTemp: [],
      ReserveID: null,
      FNbPrice: { total_price: 0, total_tax: 0 },
      fnbItems: [],
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false,
      },
      fnbItemDataArry: [],
      addonsAmount: 0,
      add_ons_array: [],
      add_ons_array_on_final_price: [],
      add_ons_total: 0,
    };
  },
  beforeMount() {
    this.language_id_new = window.localStorage.getItem("language_id_new");
    const { reserve_id } = this.$route.params;
    this.reserve_id = reserve_id;
    this.ReserveID = reserve_id;
    this.handleOfferTabChange(1);
  },
  mounted() {
    this.getReserveInfo();
  },
  computed: {
    curr_code() {
      return this.$store.getters.getGlobalCurrency.curr_code || "Sar";
    },
    director() {
      return localStorage.getItem("director");
    },
    language_id() {
      let lang_name = "en";
      if (localStorage.getItem("language")) {
        lang_name = JSON.parse(localStorage.getItem("language")).language;
      }
      return lang_name;
    },
  },
  methods: {
    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          "cinema_name",
          "langaugeId"
        ) || cinema.cinema_name;

      return name;
    },
    closeModal() {
      this.callSeatReleased();
      this.$refs.modal.hide();
      this.$router.go(-1);
    },
    closeOfferErrorModal() {
      // this.callSeatReleased();
      this.$refs.offererrormodal.hide();
      // this.$router.go(-1);
    },

    callSeatReleased() {
      makeRequestBrij("/api/external/release-seat", "POST", null, {
        reservation_id: this.ReserveID,
      }).then((result2) => {});
    },

    getReserveInfo() {
      let loader = this.$loading.show();
      makeRequestBrij(
        `/api/external/reservation-detail/${this.ReserveID}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          loader.hide();
          if (!error) {
            if (res.data && res.data.status) {
              let schedule_detail = res.data.Records[0];
              if (schedule_detail.add_ons_array.length) {
                this.add_ons_array =
                  schedule_detail.add_ons_array[0].gross_amount_addons;
                // console.log(
                //   schedule_detail.add_ons_array[0].gross_amount_addons
                // );

                this.add_ons_array_on_final_price = schedule_detail
                  .add_ons_array[0].gross_amount_addons_on_ticket
                  ? schedule_detail.add_ons_array[0]
                      .gross_amount_addons_on_ticket
                  : [];
                this.add_ons_total =
                  schedule_detail.add_ons_array[0].BoxOfficeFinal.TotalAddons;
                // quantity //addons_name //final_price
              }

              this.reservationDetails = res.data.Records[0];

              // console.log(schedule_detail, "schedule_detail");
              this.scheduleData = {
                CinameName:
                  this.getCinemaTranslatedName(schedule_detail) ||
                  schedule_detail.cine_name,
                MovieTitle:
                  this.getLangSpecificAttribute(
                    schedule_detail.altMovieContent,
                    this.getCurrentLang().brij_lang_id,
                    "mc_title"
                  ) ||
                  schedule_detail.movie_title ||
                  schedule_detail.original_title_of_movie,
                ScreenName: schedule_detail.screen_name,
                ShowDate: moment(schedule_detail.ss_actual_start_date)
                  .locale(this.getCurrentLang().iso_2 || "en")
                  .format("DD-MM-YYYY"),
                ShowTime: moment(schedule_detail.ss_start_show_time, "HH:mm")
                  .locale(this.getCurrentLang().iso_2 || "en")
                  .format("hh:mm A"),
                Location: schedule_detail.cine_address,
                Experience: schedule_detail.mf_name,
                Currency:
                  this.$store.getters.getGlobalCurrency.curr_code || "Sar",
                SeatName: schedule_detail.seat_name,
                SchID: schedule_detail.ss_id,
                //
                MovieImage: schedule_detail.md_thumbnail_url,
                runtime: schedule_detail.mrrdr_runtime,
                Genre: schedule_detail.all_genre,
                Certificate: schedule_detail.rating,
                SelectedFormat: schedule_detail.mf_name,
                Language: schedule_detail.lang_name,
                director: "",
                ticket_count: schedule_detail.seat_name.split(",").length,
                amount: schedule_detail.amount,
                fnb_total: 0,
                artwork: schedule_detail.artwork,
                altMovieContent: schedule_detail.altMovieContent,
              };

              this.scheduleData.fnb_total = 0;
              if (
                schedule_detail.hasOwnProperty("fnb_data") &&
                schedule_detail.fnb_data &&
                schedule_detail.fnb_data.hasOwnProperty("selected_fnb_items") &&
                schedule_detail.fnb_data.selected_fnb_items.length > 0
              ) {
                // console.log(
                //   schedule_detail.fnb_data.selected_fnb_items,
                //   "FNBBB"
                // );
                this.fnbItemDataArry =
                  schedule_detail.fnb_data.selected_fnb_items;

                this.fnbItemDataArry.map((z) => {
                  z["Quantity"] = z.Quantity || z.quantity;
                  z["qty"] = z.Quantity;
                  z["Qty"] = z.Quantity;
                  z["title"] = z.item_name;
                  this.scheduleData.fnb_total = +parseFloat(
                    this.scheduleData.fnb_total + z.fp_total_amount * z.Quantity
                  ).toFixed(2);
                });
              } else {
                // console.log("res.datares.datares.datares.datares.data");
              }
              // console.log(this.scheduleData.fnb_total, "scheduleData");

              if (
                schedule_detail.hasOwnProperty("selectedSeats") &&
                schedule_detail.selectedSeats.length > 0
              ) {
                this.selectedSeatsNew = schedule_detail.selectedSeats;

                if (schedule_detail.amount) {
                  this.totalAmount = +parseFloat(
                    this.scheduleData.amount
                  ).toFixed(4);
                }
                if (this.scheduleData.fnb_total) {
                  this.totalAmount = +parseFloat(
                    this.totalAmount + this.scheduleData.fnb_total
                  ).toFixed(4);
                }

                // console.log(this.add_ons_array, "add_ons_array_on_final_price");

                this.totalAmount = +parseFloat(
                  this.totalAmount + this.add_ons_total
                ).toFixed(4);
                this.timer.minutes = schedule_detail.timer_minutes;
                this.timer.seconds = schedule_detail.timer_second;
                this.startTimer();
              }
            } else {
              // setTimeout(() => {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.ErrorMessage = res.data.message;
                  this.$refs.modal.show();
                }, 1000);
              });

              // });
            }
          } else {
            this.ErrorMessage = res.data.message;
            this.$refs.modal.show();
            console.log("object");
          }
        })
        .then(() => {
          if (!this.isActivePromotionHit) {
            this.getactivepromotionsandoffers();
          }
        })
        .catch((error) => {
          this.ErrorMessage = "Something Went Wrong";
          this.$refs.modal.show();
          console.log("error", error);
        });
    },
    async getAllOfferDetailsBrij(offer) {
      let { os_id = undefined } = offer;

      let fallback = {
        status: true,
        message: "Records Successfully Fetched",
        error: null,
        Records: [],
        PromotionOfferCinemasRecords: [],
        PromotionOfferMoviesRecords: null,
        PromotionOfferDaysRecords: null,
        PromotionOfferScreensRecords: null,
        PromotionOfferSeatsTypeRecords: null,
        PromotionOfferTypesRecords: [],
        PromotionOfferBuyItems: [],
        PromotionOfferGetItems: [],
        OfferContent: [],
      };

      if (!os_id) return Promise.resolve(fallback);

      return makeRequestBrij(
        `/api/marketing/getactivepromotionsandoffers/${os_id}`,
        "GET",
        null,
        null
      )
        .then((response) => {
          const { error, res } = response;
          if (error) return fallback;

          return res.data.status ? res.data : fallback;
        })
        .catch((error) => {
          console.log(`error fetching offer details ${os_id}`, error);
          return fallback;
        });
    },
    getactivepromotionsandoffers() {
      let loader = this.$loading.show();
      this.isActivePromotionHit = true;
      let payload = {
        lang_id: this.getCurrentLang().brij_lang_id,
        limit: 1000,
        currentPage: 1,
        status: "Y",
        columnName: "os_id",
        orderBy: "desc",
      };

      // console.log("this.reservationDetails", this.reservationDetails);
      // console.log("this.selectedSeatsNew", this.selectedSeatsNew);
      let tt_id = null;
      let seat_type_id = null;

      this.selectedSeatsNew.map((x, index) => {
        if (x.tt_id) {
          tt_id = x.tt_id;
        }
        if (x.screen_seat_type_id) {
          seat_type_id = x.screen_seat_type_id;
        }
      });

      let show_date_time = moment(
        moment(
          this.reservationDetails.ss_actual_start_date,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD") +
          " " +
          moment(this.reservationDetails.ss_start_show_time, "HH:mm").format(
            "HH:mm"
          )
      ).valueOf();

      let newPayload = {
        cinema_id: this.reservationDetails.cinema_id || null,
        screen_id: this.reservationDetails.screen_id || null,
        seat_type_id: seat_type_id, // sst_id: null,
        movie_details_id: this.reservationDetails.md_id || null,
        show_date_time: this.reservationDetails.ss_start_date_time || null,
        show_actual_date_time: show_date_time || null,
        tt_id: tt_id,
      };

      payload.cinema_id = this.reservationDetails
        ? this.reservationDetails.cinema_id
        : undefined; // this.$store.getters.getSelectedBrijCinemas.cinema_id

      // this.showLoading()
      // console.log(newPayload, "newPayload");
      let packageOfferDetails = {};
      return makeRequestBrij(
        `/api/marketing/getAvailablePromotionsOffers`,
        "POST",
        null,
        newPayload
      )
        .then(({ error, res }) => {
          // console.log("getActivePromotionsandOffers", { res });
          let { data } = res;

          let allOffers = res.data.status ? data.Records : [];
          let filteredOffers = allOffers || [];
          this.offerGroupTypes = res.data.status ? data.offerGroup : [];
          if (allOffers.length) {
            this.OffersData = allOffers;
            this.$refs.OfferPopup.show();
            if (allOffers[0].hasOwnProperty("is_employee_offer")) {
              filteredOffers = allOffers.filter(
                (z) => z.is_employee_offer == "N"
              );
            }
          }

          return filteredOffers;
        })
        .then((offerListDetails) => {
          return Promise.all(
            offerListDetails.map((x) =>
              this.getAllOfferDetailsBrij(x).then((d) => ({
                ...x,
                offer: x,
                details: d,
              }))
            )
          );
        })
        .then((offerListDetails) => {
          // setting all offers as cinema offer
          // offerListDetails.forEach((x, offerDataIndex) => {
          //   if (
          //     this.getPackageOfferData.oc_id &&
          //     x.oc_id == this.getPackageOfferData.oc_id
          //   ) {
          //     packageOfferDetails = { ...x, offerDataIndex };
          //     // offerListDetails = packageOfferDetails;
          //   }
          //   x.OfferID = 45; // mpm_d_id
          // });

          // console.log("offerListDetails", { offerListDetails });
          // let isPackageComboOfferId =
          //   this.getPackageOfferData && this.getPackageOfferData.os_id
          //     ? this.getPackageOfferData.os_id
          //     : "";
          // if (isPackageComboOfferId) {
          //   // console.log("Inside isPackageComboOfferId");
          //   offerListDetails = offerListDetails.filter((elem) => {
          //     return elem.os_id == isPackageComboOfferId;
          //   });
          // }
          this.offerListDetails = offerListDetails;
          if (offerListDetails.length > 0) {
            this.handleOfferTabChange(offerListDetails[0].offer_group_type_id);
          } else {
            this.handleOfferTabChange(1);
          }
        })
        .finally(() => {
          // console.log({ packageOfferDetails }, "packageOfferDetails");
          // console.log(packageOfferDetails.os_id, "packageOfferDetails.os_id");
          // console.log(
          //   packageOfferDetails.offerDataIndex,
          //   "packageOfferDetails.offerDataIndex"
          // );
          // this.hideLoading()
          // if (
          //   packageOfferDetails.os_id &&
          //   packageOfferDetails.offerDataIndex !== undefined &&
          //   packageOfferDetails.offerDataIndex !== null
          // ) {
          //   let CustomIndex =
          //     this.offerListDetails && this.offerListDetails.length == 1
          //       ? 0
          //       : packageOfferDetails.offerDataIndex;
          //   console.log("Inside This Auto Reserve Function", CustomIndex);
          //   this.reserveSelectedOfferPromotion(
          //     packageOfferDetails,
          //     null,
          //     CustomIndex //packageOfferDetails.offerDataIndex // 0
          //   );
          // }
          // this.reserveSelectedOfferPromotion()

          loader.hide();
        });
    },
    reserveSelectedOfferPromotion(data, id, indx) {
      // console.log({ reserveSelectedOfferPromotion: data });

      this.appliedBrijVoucher = null;
      this.cardInputErrorMsg = "";
      this.errorMessage = "";
      this.cardInputsuccessMsg = "";
      this.appliedPromoName = "";
      this.appliedOfferType = "";

      this.Offerindex = indx;
      let payload = {};
      // console.log(data, "Inside dataaaaa reserve Offer");
      const arabicOfferData = data.offerContent.find(
        (item) => item.content_lang_id === 3
      );
      const englishOfferData = data.offerContent.find(
        (item) => item.content_lang_id === 1
      );
      if (this.langName == "ar") {
        this.appliedPromoName =
          arabicOfferData && arabicOfferData.offer_title.trim()
            ? arabicOfferData.offer_title
            : englishOfferData
            ? englishOfferData.offer_title
            : englishOfferData.offer_title;
      } else {
        this.appliedPromoName = englishOfferData
          ? englishOfferData.offer_title
          : englishOfferData.offer_title;
      }
      // this.appliedPromoName =
      //   this.langName == "ar"
      //     ? data.offerContent[0].offer_title
      //     : data.offerContent[0].offer_title == "" ||
      //       !data.offerContent[0].offer_title
      //     ? data.offer_title
      //     : this.getSafe(() => data.offer_title, "Offer");
      // this.selectedPromotionID = data.ShowbizzVoucherID
      // payload = {
      //   PromotionName: data.Name,
      //   ReserveID: this.ReserveID,
      //   PromotionID: data.ShowbizzVoucherID,
      //   isPromoCode: 0,
      //   TransactionType: 'Normal',
      // }
      // console.log(data.details);
      // let cust_token = TokenService.getToken();
      let offer = {
        cinema_id: this.reservationDetails.cinema_id,
        cinema_name: this.reservationDetails.cine_name,
        isTicket: true,
        reservation_id: this.ReserveID,
        // customer_id: cust_token || "",
        md_id: this.reservationDetails.md_id,
        net_amount: this.reservationDetails.net_amount,
        total_amount: this.scheduleData.amount, // + getRateCardAddonsTotal(add_ons_array),
        total_ticket: this.reservationDetails.selectedSeats.length,
        fnb_items: [],
        // voucher_title: this.promoCodeValue,
        // voucher_code: this.promoCodeValue,
        oc_id: this.getSafe(
          () => data.details.PromotionOfferTypesRecords[0].oc_id
        ),
      };

      if (
        this.reservationDetails.fnb_data &&
        this.reservationDetails.fnb_data.selected_fnb_items &&
        this.reservationDetails.fnb_data.selected_fnb_items.length
      ) {
        offer.isComboApplied = true;
        offer.fnb_items =
          this.reservationDetails.fnb_data.selected_fnb_items || [];
        offer.fnb_total_amount = this.reservationDetails.fnb_data.fnb_price.total_price;

        offer.fnb_total_item = this.reservationDetails.fnb_data.selected_fnb_items.length;

        offer.fnb_net_amount =
          this.reservationDetails.fnb_data.fnb_price.total_price -
          this.reservationDetails.fnb_data.fnb_price.total_tax;
      }

      this.showLoading();
      // console.log({ payload, offer });

      makeRequestBrij(`/api/marketing/v2/verifyPromotion`, "POST", null, offer)
        .then((result) => {
          const { error, res } = result;
          // console.log({ data: res.data });

          if (res.data.status) {
            // this.getReserveInfo(this.ReserveID, '1')
            this.isFNBHitOnce = true;
            this.appliedBrijVoucher = res.data;
            this.appliedOfferType = this.appliedBrijVoucher
              ? String(this.appliedBrijVoucher.Records[0].offer_type_id)
              : "";

            // console.log(res.data, "res.data verifyPromotion");
            this.showDiscounttag = true;
            this.cardInputsuccessMsg = res.data.message;
            // this.removeEwallet();
            // this.removeLoyality(null, false);
          } else {
            this.ErrorMessage = res.data.message;
            this.$refs.offererrormodal.show();

            this.appliedBrijVoucher = null;
            this.cardInputErrorMsg = res.data.message;
            this.showDiscounttag = false;
          }
          return res.data;
        })
        .then(async (response) => {
          let updateObj = {
            reservation_id: this.ReserveID,
          };
          if (
            response.status &&
            response.Records &&
            response.Records.length > 0
          ) {
            let OfferDetails = response.Records[0];
            if (OfferDetails && [3, 9].includes(OfferDetails.offer_type_id)) {
              this.calculateOfferDetails(OfferDetails);
            }
            updateObj["oc_id"] = OfferDetails.oc_id;
            updateObj["offer_promotion_payload"] = JSON.stringify(offer);
            return updateObj;
          } else {
            return updateObj;
          }
        })
        .then((responseObj) => {
          // clear voucher if any
          // console.log("9th Voucher Hit");
          return makeRequestBrij(
            `/api/external/save-voucher`,
            "POST",
            null,
            responseObj
          )
            .then((result) => ({}))
            .catch((e) => ({}));
        })
        // .then((result) => {
        //   return this.resetGiftCardDetails();
        // })
        .catch((error) => {
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
          console.log("error", error);
        })
        .finally(() => {
          this.$refs["OfferPopup"].hide();
          this.hideLoading();
        });
    },
    handleOfferTabChange(offerTypeId) {
      // console.log({ offerTypeId }, "from parent");
      let selectedOfferGroupType = offerTypeId
        ? offerTypeId
        : this.offerGroupTypes.length
        ? this.offerGroupTypes[0]["ogt_id"]
        : 1;
      this.filteredOfferSelection =
        this.offerListDetails && this.offerListDetails.length > 0
          ? this.offerListDetails.filter((offerObj) => {
              // console.log(offerObj.offer_group_type_id == this.selectedOfferGroupType, "offerObj.offer_group_type_id == this.selectedOfferGroupType")
              return offerObj.offer_group_type_id == selectedOfferGroupType;
            })
          : [];
      // this.fetchOffers()
    },
    handleApplyOffer(offer) {
      console.log("Inside Cnfirm Details Page", offer);
      this.isOfferApplied =
        offer &&
        Object.keys(offer).length > 0 &&
        offer.hasOwnProperty("os_id") &&
        offer.os_id
          ? true
          : false;
      this.reserveSelectedOfferPromotion(offer, null, 0);
      this.showOfferModal = false; // close modal if needed
    },
    removeSelectedFnb() {
      if (this.fnbItemDataArry && this.fnbItemDataArry.length) {
        this.fnbItemDataArry.forEach((_item) => {
          if (
            _item.hasOwnProperty("isAddedByOffer") &&
            _item["isAddedByOffer"] == "Y"
          ) {
            let removeQty = parseInt(_item["offerAddedQty"] || 0);
            _item["quantity"] -= removeQty;
            _item["Qty"] = _item["quantity"];
            _item["Quantity"] = _item["quantity"];
            _item["isAddedByOffer"] = "N";
            // _item['offerAddedQty'] = 0;
            _item["offerAddedQty"] -= _item["offerAddedQty"] ? removeQty : 0;
          }
        });
        this.fnbItemDataArry = this.fnbItemDataArry.filter(
          (_item) => _item["quantity"] > 0
        );
        this.onUpdateFnbCartItems(this.fnbItemDataArry);
      }
    },
    removeAddedOffer() {
      let payload = {
        ReserveID: this.ReserveID,
        PromotionID: this.selectedPromotionID,
        TransactionType: "Normal",
      };
      this.showLoading();

      Promise.resolve(this.promoCodeValue)
        .then((result) => {
          // console.log("10th Voucher Hit");
          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
            voucher_code: null,
          })
            .then((result) => {
              this.isOfferApplied = false;
              this.removeSelectedFnb();
            })
            .catch((e) => ({}));
        })
        // .then((result) => {
        //   return this.resetGiftCardDetails();
        // })
        .then(() => {
          this.cardInputErrorMsg = "";
          this.cardInputsuccessMsg = "";
          this.promoCodeValue = "";
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
          this.hideLoading();
        });
    },
    getOfferSpecificFnbItems(itemIds = []) {
      return new Promise((resolve) => {
        if (itemIds.length == 0) {
          resolve([]);
        } else {
          let payload = {
            cinema_id: this.reservationDetails.cinema_id,
            specificItems: itemIds,
          };

          makeRequestBrij(`/api/external/fnb-items`, "POST", null, payload)
            .then((response) => {
              const { data } = response.res;
              if (data && data.status && data.Records) {
                resolve([...data.Records.Records]);
              } else {
                resolve([]);
              }
            })
            .catch((err) => {
              console.log("Error fetchFnbItems:", err);
            })
            .finally(() => {});
        }
      });
    },

    async calculateOfferDetails(offer) {
      if (offer.offer_type_id == 9) {
        let TotalSeats = this.reservationDetails.selectedSeats.length;
        let FinalFNBArray = [];
        let selectedFnbItems = [];
        let totalTicketOffer = 0;

        totalTicketOffer = parseInt(
          Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket))
        );

        if (
          offer.oc_max_no_of_ticket_per_transaction &&
          totalTicketOffer > offer.oc_max_no_of_ticket_per_transaction &&
          offer.oc_max_no_of_ticket_per_transaction > 0
        ) {
          totalTicketOffer = offer.oc_max_no_of_ticket_per_transaction;
        }

        if (TotalSeats >= offer.oc_buy_no_of_ticket) {
          if (offer.oc_is_combo_with_fnb == "Y") {
            let fnbItemsArray = offer.fnb_group_data || [];
            let fnbItemIds = fnbItemsArray.map((x) => x.oc_buy_item_code);
            let fnbItems = await this.getOfferSpecificFnbItems(fnbItemIds);
            for (let i = 0; i < fnbItemsArray.length; i++) {
              let itemObj = fnbItemsArray[i];

              let offerFnbItem = fnbItems.filter(
                (x) =>
                  x.item_code == itemObj.oc_buy_item_code ||
                  itemObj.oc_buy_item_id == x.item_id
              );
              if (offerFnbItem.length > 0) {
                if (
                  this.reservationDetails.fnb_data &&
                  this.reservationDetails.fnb_data.hasOwnProperty(
                    "selected_fnb_items"
                  ) &&
                  this.reservationDetails.fnb_data.selected_fnb_items &&
                  this.reservationDetails.fnb_data.selected_fnb_items.length > 0
                ) {
                  selectedFnbItems = this.reservationDetails.fnb_data
                    .selected_fnb_items;
                }

                let itemQty =
                  parseInt(itemObj.oc_buy_no_of_item || 1) *
                  parseInt(totalTicketOffer || 1);
                let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                  (x) => x.item_code == itemObj.oc_buy_item_code
                );
                // console.log(checkAlreadyAddedItem, "checkAlreadyAddedItem");
                if (checkAlreadyAddedItem > -1) {
                  if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                    // DO NOTHING
                    selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                    selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer =
                      "Y";
                    selectedFnbItems[
                      checkAlreadyAddedItem
                    ].offerAddedQty = itemQty;
                  } else {
                    selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                    selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer =
                      "Y";
                    selectedFnbItems[
                      checkAlreadyAddedItem
                    ].offerAddedQty = itemQty;
                  }
                } else {
                  let fnbObj = {
                    ...offerFnbItem[0],
                    Qty: itemQty,
                    isAddedByOffer: "Y",
                    offerAddedQty: itemQty,
                  };
                  selectedFnbItems.push(fnbObj);
                }
              } else {
                this.removeAddedOffer();
              }
            }
            if (selectedFnbItems.length > 0) {
              // console.log(
              //   selectedFnbItems,
              //   "selectedFnbItemsselectedFnbItemsselectedFnbItems"
              // );
              selectedFnbItems.forEach((x) => {
                let TotalPrice =
                  +parseFloat(x.fp_total_amount).toFixed(4) * x.Qty;
                let TotalTax =
                  +parseFloat(x.fp_total_amount - x.fp_amount).toFixed(4) *
                  x.Qty;

                this.FNbPrice["total_price"] = +parseFloat(
                  this.FNbPrice["total_price"] + TotalPrice
                ).toFixed(4);
                this.FNbPrice["total_tax"] = +parseFloat(
                  this.FNbPrice["total_tax"] + TotalTax
                ).toFixed(4);
                let obj = {
                  ...x,
                  Quantity: x.Qty,
                  quantity: x.Qty,
                  total_price: TotalPrice,
                  total_tax: TotalTax,
                };
                FinalFNBArray.push(obj);
                this.totalAmount = +parseFloat(
                  parseFloat(this.totalAmount) + parseFloat(TotalPrice)
                ).toFixed(4);
              });
              // console.log(FinalFNBArray, "FinalFNBArrayFinalFNBArray");
              this.onUpdateFnbCartItems(FinalFNBArray);
              // this.finalCalculationFnb(FinalFNBArray);
            }
          } else {
          }
        } else {
          this.removeAddedOffer();
        }
      } else if (offer.offer_type_id == 3) {
        let selectedFnbItems = [];
        if (
          this.reservationDetails.fnb_data &&
          this.reservationDetails.fnb_data.hasOwnProperty(
            "selected_fnb_items"
          ) &&
          this.reservationDetails.fnb_data.selected_fnb_items &&
          this.reservationDetails.fnb_data.selected_fnb_items.length > 0
        ) {
          selectedFnbItems = this.reservationDetails.fnb_data
            .selected_fnb_items;
        }
        if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "Y" &&
          offer.oc_is_combo_with_fnb == "N"
        ) {
          let TotalSeats = this.reservationDetails.selectedSeats.length;
          if (TotalSeats >= offer.oc_buy_no_of_ticket) {
            let fnbItemIds = [offer.oc_get_item_code];
            let fnbItems = await this.getOfferSpecificFnbItems(fnbItemIds);
            let offerFnbItem = fnbItems.filter(
              (x) => x.item_code == offer.oc_get_item_code
            );

            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            let totalFreeItemQty = 0;
            if (
              offer.oc_buy_no_of_ticket == offer.oc_get_item_count &&
              offer.oc_buy_item_count > 1
            ) {
              totalFreeItemQty = parseInt(
                Math.floor(
                  TotalSeats /
                    parseInt(
                      offer.oc_buy_no_of_ticket + offer.oc_get_item_count
                    )
                ) * offer.oc_get_item_count
              );
            } else {
              totalFreeItemQty = parseInt(
                Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket)) *
                  offer.oc_get_item_count
              );
            }

            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                  isAddedByOffer: "Y",
                  offerAddedQty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
            }
          } else {
            this.removeAddedOffer();
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "N" &&
          offer.oc_is_combo_with_fnb == "N"
        ) {
          let TotalSeats = this.reservationDetails.selectedSeats.length;
          if (TotalSeats >= offer.oc_buy_no_of_ticket) {
            let fnbItemIds = [offer.oc_get_item_code];
            let fnbItems = await this.getOfferSpecificFnbItems(fnbItemIds);
            let offerFnbItem = fnbItems.filter(
              (x) => x.item_code == offer.oc_get_item_code
            );

            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            let totalFreeItemQty = 0;
            if (
              offer.oc_buy_no_of_ticket == offer.oc_get_item_count &&
              offer.oc_buy_item_count > 1
            ) {
              totalFreeItemQty = parseInt(
                Math.floor(
                  TotalSeats /
                    parseInt(
                      offer.oc_buy_no_of_ticket + offer.oc_get_item_count
                    )
                ) * offer.oc_get_item_count
              );
            } else {
              totalFreeItemQty = parseInt(
                Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket)) *
                  offer.oc_get_item_count
              );
            }

            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                  isAddedByOffer: "Y",
                  offerAddedQty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
            }
          } else {
            this.removeAddedOffer();
            // console.log(
            //   "Please select atleast " +
            //     offer.oc_buy_no_of_ticket +
            //     " ticket(s)"
            // );
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "Y" &&
          offer.oc_is_combo_with_fnb == "Y"
        ) {
          let array = selectedFnbItems.filter((singleItem) => {
            return (
              (singleItem.item_id == offer.oc_buy_item_id ||
                singleItem.item_code == offer.oc_buy_item_code) &&
              singleItem.Qty >= offer.oc_buy_item_count
            );
          });
          let fnbItemIds = [offer.oc_buy_item_id, offer.oc_get_item_id];
          let fnbItems = await this.getOfferSpecificFnbItems(fnbItemIds);
          let toBuyItem = fnbItems.filter(
            (x) =>
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
          );
          let offerFnbItemIndex = selectedFnbItems.findIndex(
            (fnbItem) =>
              (offer.oc_get_item_code &&
                fnbItem.item_code == offer.oc_get_item_code) ||
              fnbItem.item_id == offer.oc_get_item_id
          );
          let itemCount = 0;
          selectedFnbItems.forEach((x) => {
            if (
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
            ) {
              itemCount += x.quantity;
            }
          });

          let totalFreeItemQty = 0;
          if (
            offer.oc_buy_item_count == offer.oc_get_item_count &&
            offer.oc_buy_item_count > 1
          ) {
            totalFreeItemQty = parseInt(
              Math.floor(
                itemCount /
                  parseInt(offer.oc_buy_item_count + offer.oc_get_item_count)
              ) * offer.oc_get_item_count
            );
          } else {
            totalFreeItemQty = parseInt(
              Math.floor(itemCount / parseInt(offer.oc_buy_item_count)) *
                offer.oc_get_item_count
            );
          }

          if (array && array.length > 0) {
            let offerFnbItem = fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                  isAddedByOffer: "Y",
                  offerAddedQty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
              console.log("NO FNB ITEM FOUND");
            }
          } else {
            let offerFnbItem = fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let msg = `Offer not applicable on selected items`;
            if (toBuyItem && toBuyItem.length > 0) {
              msg =
                "Offer is applicable on puchasing" +
                offer.oc_buy_item_count +
                " " +
                toBuyItem[0].item_name;
            }
            this.removeAddedOffer();
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "N" &&
          offer.oc_is_combo_with_fnb == "Y"
        ) {
          let fnbItemIds = [offer.oc_buy_item_id, offer.oc_get_item_id];
          let fnbItems = await this.getOfferSpecificFnbItems(fnbItemIds);
          let array = selectedFnbItems.filter((singleItem) => {
            return (
              (singleItem.item_id == offer.oc_buy_item_id ||
                singleItem.item_code == offer.oc_buy_item_code) &&
              singleItem.quantity >= offer.oc_buy_item_count
            );
          });
          let toBuyItem = fnbItems.filter(
            (x) =>
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
          );
          let offerFnbItemIndex = selectedFnbItems.findIndex(
            (fnbItem) =>
              (offer.oc_get_item_code &&
                fnbItem.item_code == offer.oc_get_item_code) ||
              fnbItem.item_id == offer.oc_get_item_id
          );
          let itemCount = 0;
          selectedFnbItems.forEach((x) => {
            if (
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
            ) {
              itemCount += x.quantity;
            }
          });

          let totalFreeItemQty = 0;
          if (
            offer.oc_buy_item_count == offer.oc_get_item_count &&
            offer.oc_buy_item_count > 1
          ) {
            totalFreeItemQty = parseInt(
              Math.floor(
                itemCount /
                  parseInt(offer.oc_buy_item_count + offer.oc_get_item_count)
              ) * offer.oc_get_item_count
            );
          } else {
            totalFreeItemQty = parseInt(
              Math.floor(itemCount / parseInt(offer.oc_buy_item_count)) *
                offer.oc_get_item_count
            );
          }

          if (array && array.length > 0) {
            let offerFnbItem = fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  selectedFnbItems[checkAlreadyAddedItem].isAddedByOffer = "Y";
                  selectedFnbItems[
                    checkAlreadyAddedItem
                  ].offerAddedQty = itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                  isAddedByOffer: "Y",
                  offerAddedQty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
              console.log("NO FNB ITEM FOUND");
            }
          } else {
            this.removeAddedOffer();
            let msg = `Offer not applicable on selected items`;
            if (toBuyItem && toBuyItem.length > 0) {
              msg =
                "Offer is applicable on puchasing" +
                offer.oc_buy_item_count +
                " " +
                toBuyItem[0].item_name;
            }
          }
        }
      }
    },
    finalCalculationFnb(selectedFnbItems) {
      let FinalFNBArray = [];
      if (selectedFnbItems.length > 0) {
        selectedFnbItems.forEach((x) => {
          let TotalPrice = +parseFloat(x.fp_total_amount).toFixed(4) * x.Qty;
          let TotalTax =
            +parseFloat(x.fp_total_amount - x.fp_amount).toFixed(4) * x.Qty;

          this.FNbPrice["total_price"] = +parseFloat(
            this.FNbPrice["total_price"] + TotalPrice
          ).toFixed(4);
          this.FNbPrice["total_tax"] = +parseFloat(
            this.FNbPrice["total_tax"] + TotalTax
          ).toFixed(4);
          let obj = {
            ...x,
            Quantity: x.Qty,
            quantity: x.Qty,
            total_price: TotalPrice,
            total_tax: TotalTax,
          };
          FinalFNBArray.push(obj);
          this.totalAmount = +parseFloat(
            parseFloat(this.totalAmount) + parseFloat(TotalPrice)
          ).toFixed(4);
        });
        this.onUpdateFnbCartItems(FinalFNBArray);
      }
    },
    async onUpdateFnbCartItems(fnbItems) {
      this.showLoading();
      // console.log(fnbItems, "fnbItemsfnbItems");

      let selectedItem = [];
      if (fnbItems && fnbItems.length > 0) {
        fnbItems.map((_it) => {
          if (_it.Qty > 0) {
            console.log("fnbItemData if is working");
            let TotalPrice =
              +parseFloat(_it.fp_total_amount).toFixed(4) * _it.Qty;
            let TotalTax =
              +parseFloat(_it.fp_total_amount - _it.fp_amount).toFixed(4) *
              _it.Qty;

            let obj = {
              // ..._it.FnbDetail,
              Quantity: _it.Qty,
              quantity: _it.Qty,
              Qty: _it.Qty,
              qty: _it.Qty,
              total_price: TotalPrice,
              total_tax: TotalTax,
              item_name: _it.item_name || "",
              item_id: _it.item_id || "",
              item_code: _it.item_code || "",
              alternate_lang_item_name: _it.alternate_item_name || "",
              fp_total_amount: _it.fp_total_amount,
              is_combo: _it.is_combo || "N",
              is_premier_item: _it.is_premier_item || "N",
              ready_to_serve: _it.ready_to_serve || "N",
              final_combo_array: _it.final_combo_array || [],
              has_modifiers: _it.has_modifiers || "N",
              final_modifier_array: _it.final_modifier_array || [],
              combo_pack: _it.combo_pack || [],
            };
            selectedItem.push(obj);
          }
        });
      }
      // console.log(selectedItem, "selectedItemselectedItem Inside CheckOut");

      let payload = {
        reservation_id: this.ReserveID,
        selected_fnb_items: fnbItems || selectedItem, //selectedItem
        fnb_price: this.FNbPrice,
        category_id: 2,
      };

      try {
        const result = await makeRequestBrij(
          "/api/external/save-fnb-items",
          "POST",
          null,
          payload
        );
        const { error, res } = result;
        const { data } = res.data;

        if (!error && res.data.status) {
          this.hideLoading();
          // console.log(this.isFNBHitOnce, "this.isFNBHitOnce");
          // console.log(fnbItems, "onUpdateCart Func Hit");
          if (this.isFNBHitOnce) {
            let appliedFNBItemInBrijVoucher =
              this.appliedBrijVoucher &&
              Object.keys(this.appliedBrijVoucher).length > 0
                ? this.appliedBrijVoucher.Records[0].fnb_group_data
                : [];

            if (appliedFNBItemInBrijVoucher.length > 0) {
              let appliedFNBItemCodeOnOffer =
                appliedFNBItemInBrijVoucher[0].selectedFnbItem.item_code;
              // console.log(
              //   appliedFNBItemCodeOnOffer,
              //   "appliedFNBItemCodeOnOffer"
              // );

              if (appliedFNBItemCodeOnOffer) {
                let customOrder = fnbItems.filter(
                  (elem) => elem.item_code == appliedFNBItemCodeOnOffer
                );
                let customIndex = customOrder[0].length - 1;
                // console.log(customOrder, "customOrder");

                // await this.onCustomizeCombo(customOrder[0], customIndex);

                this.ComboPackArray = [];
                if (
                  customOrder[0].hasOwnProperty("combo_pack") &&
                  customOrder[0].combo_pack.length > 0
                ) {
                  this.selectedTempItem = customOrder[0];
                  this.SelectedComboIndex = customIndex;

                  this.ComboPackArray = _.cloneDeep(customOrder[0].combo_pack);
                  // this.ComboPackArray = this.ComboPackArray.forEach((elem) => {
                  //   return elem.combo_items.forEach((data) => {
                  //     return (data.quantity = 0);
                  //   });
                  // });
                  if (
                    customOrder[0].Qty > 1 ||
                    customOrder[0].Quantity > 1 ||
                    customOrder[0].qty > 1 ||
                    customOrder[0].quantity > 1
                  ) {
                    // console.log("Working Inside quantity increase");
                    this.ComboPackArray.forEach((_item) => {
                      // Assign the quantity to _item
                      _item["quantity"] =
                        customOrder[0].Qty ||
                        customOrder[0].Quantity ||
                        customOrder[0].qty ||
                        customOrder[0].quantity ||
                        0; // Default value in case all are undefined

                      _item.combo_items.forEach((data) => {
                        if (data["quantity"] > 0) {
                          data["quantity"] =
                            customOrder[0].Qty ||
                            customOrder[0].Quantity ||
                            customOrder[0].qty ||
                            customOrder[0].quantity ||
                            0;
                        } else {
                          data["quantity"] = 0;
                        }
                      });
                    });
                  }
                  this.isComboPackModalVisible = true;
                  if (this.ComboPackArray && this.ComboPackArray.length > 0) {
                    this.showTotalFNBItemsCountInCombo = this.ComboPackArray.map(
                      (data) => {
                        return data.combo_items.length;
                      }
                    ).reduce(
                      (accumulator, currentValue) => accumulator + currentValue,
                      0
                    );
                  }

                  // this.$refs["comboPackModal"].show();
                  // console.log("Modal shown successfully");
                }
              }
            }
          }
        } else {
          // Show error modal
          this.$root.$emit("bv::show::modal", "errorModal");
        }
      } catch (error) {
        console.log("Error on Vue front:", error);
      } finally {
        this.hideLoading();
        this.getReserveInfo(this.ReserveID, false);
      }
    },
    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        this.timer.seconds =
          this.timer.seconds > 0 ? parseFloat(this.timer.seconds) - 1 : 0;

        if (parseFloat(this.timer.seconds) < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }

        if (parseFloat(this.timer.seconds) <= 0 && this.timer.minutes > 0) {
          this.timer.seconds = 59;
          this.timer.minutes =
            this.timer.minutes > 0 ? parseFloat(this.timer.minutes) - 1 : "00";
        }
        if (
          parseFloat(this.timer.minutes) == 0 &&
          parseFloat(this.timer.seconds) == 0
        ) {
          this.timer.seconds = "00";
          this.ErrorMessage = "Session Expired";
          this.$refs["modal"].show();

          clearInterval(this.timerStartFunction);
          return false;
        } else {
        }
      }, 1000);
    },
    getReserveDetails: function(reserve_id) {
      let loader = this.$loading.show();
      let payload = {
        reserve_id: reserve_id,
      };
      bookingService
        .getReserveDetails(payload)
        .then((response) => {
          loader.hide();
          const { data } = response;
          if (data && data.status) {
            this.reserveDetails = data.data;
          } else {
            this.$refs.modal.show();
            this.ErrorMessage = data.Message || data.message;
          }
        })
        .catch((err) => {
          loader.hide();
          this.$refs.modal.show();
        });
    },
    onClickProceed: function() {
      this.$router.push({
        path: "/payment/" + this.reserve_id,
      });
    },
  },
};
</script>
<style>
.extra-ticket-details {
  font-size: 24px;
}

.ticket-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 32px;
  border-top: 2px solid;
  border-bottom: 2px solid;
  padding: 10px;
}

.font-50 {
  font-size: 50px;
}

.movie-name {
  font-size: 35px;
  font-weight: bold;
  margin-right: 30px;
}

.rtl {
  direction: rtl;
}

.opacity {
  opacity: 0.4;
  transition: 0.3s ease-in;
}

.slick-center .opacity {
  opacity: 1;
}

.date-number {
  line-height: 1;
  font-size: 125px;
}

.month {
  font-size: 40px;
  line-height: 1;
  margin-bottom: 10px;
  font-weight: lighter;
}

.day {
  font-size: 50px;
  line-height: 1;
}

.showtime,
.format-list {
  padding: 0;
  text-align: center;
  list-style: none;
}

.format {
  padding: 0px 15px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  font-size: 30px;
  border: 2px solid #fff;
}

.format.active {
  border: 2px solid #d3d3d3;
  background-color: #86bf3f;
}

.showtime .fill-green {
  border: 2px solid #86bf3f;
}

.showtime li {
  margin: 0 15px;
  width: 108px;
  height: 108px;
  border-radius: 15px;
  background: #fff;
  border: 2px solid #e6e6e6;
  display: inline-block;
  color: #e6e6e6;
  padding-top: 12px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transform: scale(1);
  transition: 0.3s ease;
}

.timing-slot {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}

.fill-green .filling {
  color: #000;
  background: #86bf3f;
  border: 2px solid #86bf3f;
}

.fill-height .filling {
  height: 40%;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}

.filling {
  position: absolute;
  background: #e6e6e6;
  width: 100%;
  display: table;
  bottom: 0;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}

.showtime .fill-green .time,
.showtime .fill-red .time,
.showtime .fill-yellow .time {
  color: #434345;
  font-size: 14px;
}

.showtime li.active,
.showtime li:hover {
  transform: scale(1.3);
  transition: 0.3s ease;
}

.fixed-next {
  position: fixed;
  bottom: 8%;
  left: calc(50% - 125px);
}

.ticket-details {
  font-size: 40px;
}
.check_offer {
  background-color: var(--green);
  color: #fff;
  border: 1px solid var(--green);
  border-radius: 6px;
  font-size: 25px;
}
#OfferPopup .modal-content {
  font-size: 25px;
}
#OfferPopup .nav-link {
  font-size: 25px;
}
#OfferPopup .nav-tabs .nav-link.active {
  color: #cc202e !important;
}
#OfferPopup .close {
  font-size: 50px !important;
}
#OfferPopup .modal-header .close {
  padding: 0px !important;
  margin: 0px !important;
}
#OfferPopup .modal-header {
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kiosk/confirmDetails.vue